import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import DownloadPanel from "./DownloadPanel";
import { CURRENT_HOST, CURRENT_MAIN_HOST } from "../constant";

import "./Headers.css";
import pcinfo from "../utils/pcid";
import asd from "../utils/asd";
import logo from "../assets/soutuya-logo.svg";
import { dialog4, dialog5 } from "../utils/dialog";
import serverInfo from "../utils/server-info";
import parse_url_fromstring from "../utils/parse_url_fromstring";
import uuid from "../utils/uuid";

import { parseSourceUrl } from "../api";
import { message } from "antd";

export default class Headers extends Component {
    showLoginModel = () => {
        /* global layer */
        /* global QRCode */
        layer.open({
            type: 1,
            title: `<div style="display:flex;align-items:center;">
            <i class="layui-icon layui-icon-login-wechat" style="font-size: 26px; color: #3a3d48;"></i>
            <div style="margin-left:5px;">用户登录</div>
            </div>`,
            area: "300px;",
            shade: 0.8,
            id: "LAY_login", //设定一个id，防止重复弹出
            btnAlign: "c",
            moveType: 1, //拖拽模式，0或者1
            content: `<div style="padding: 50px; line-height: 22px; background-color: #393D49; color: #fff; font-weight: 300;">
                    <p>
                        <div id="qr-img" style="width:200px;height:200px;text-align:center;position:relative;">
                            
                        </div>
                    </p>
                    <div style="height:30px;"></div>
                    <p>
                    请使用“搜图鸭”小程序
                    <br/>
                    我的-->扫一扫
                    <br/>
                    上方二维码
                    </p>
                    <p>
                    您的下载次数和会员信息和小程序同步
                    </p>
            </div>`,
        });

        this.makeQR();
        const req = fetch(`https://${CURRENT_HOST}/fresh_qr`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: `pcinfo=${pcinfo}`,
        });
        req
            .then((r) => r.json())
            .then((res) => {
                if (res.state === 200) {
                    this.makeQR(res.id);
                    document.getElementById("qr-loading").style.display = "none";
                    const scaned = new Promise((resolve) => {
                        const timer = setInterval(() => {
                            const req1 = fetch(
                                `https://${CURRENT_HOST}/fresh_qr` +
                                `?qrid=${res.id}&pcinfo=${pcinfo}`
                            );
                            req1
                                .then((r) => r.json())
                                .then((resps) => {
                                    if (resps.state === 200) {
                                        clearInterval(timer);
                                        resolve();
                                    } else if (resps.state === 204) {
                                        throw "close form";
                                    }
                                })
                                .catch(() => {
                                    clearInterval(timer);
                                    try {
                                        document.getElementById("qr-loading").style.display =
                                            "none";
                                        document.getElementById("qr-loading-err").style.display =
                                            "flex";
                                    } catch {
                                        //nothing todo
                                    }
                                });
                        }, 300);
                    });
                    let click = false;
                    document
                        .querySelector(".layui-layer-close")
                        .addEventListener("click", () => {
                            if (click) return;
                            click = true;
                            this.props.login_cancel({
                                pcinfo,
                                qrid: res.id,
                            });
                            console.log("close");
                        });
                    scaned.then(() => {
                        document.getElementById("qr-loading-ok").style.display = "flex";
                        this.props.login_in({
                            qrid: res.id,
                            pcinfo,
                        });
                    });
                } else {
                    throw "err";
                }
            })
            .catch(() => {
                document.getElementById("qr-loading").style.display = "none";
                document.getElementById("qr-loading-err").style.display = "flex";
            });
    };
    makeQR = (qrid = "no") => {
        document.getElementById(
            "qr-img"
        ).innerHTML = `<div id="qr-loading" style="position:absolute;display:flex;justify-content:center;align-items:center;top:0;left:0;width:200px;height:200px;background:rgba(255,255,255,0.9);">
        <i class="layui-icon layui-icon-loading rotate" style="font-size: 60px; color: #1E9FFF;"></i> 
    </div>
    <div id="qr-loading-err" style="position:absolute;display:none;justify-content:center;align-items:center;top:0;left:0;width:200px;height:200px;background:rgba(255,255,255,0.9);">
        <i class="layui-icon layui-icon-unlink" style="font-size: 60px; color: #1E9FFF;"></i> 
    </div>
    <div id="qr-loading-ok" style="position:absolute;display:none;justify-content:center;align-items:center;top:0;left:0;width:200px;height:200px;background:rgba(255,255,255,0.9);">
        <i class="layui-icon layui-icon-ok-circle" style="font-size: 60px; color: green;"></i> 
    </div>`;
        const time = Date.now();
        new QRCode(document.getElementById("qr-img"), {
            text: `http://pc.soutuya.com?stamp=${time}&pcinfo=${pcinfo}&qrid=${qrid}`,
            // text: `http://pc.${CURRENT_MAIN_HOST}?stamp=${time}&pcinfo=${pcinfo}&qrid=${qrid}`,
            width: 200,
            height: 200,
            colorDark: "#3a3d48",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
        });
    };
    static propTypes = {
        login: PropTypes.string.isRequired,
        login_out: PropTypes.func.isRequired,
        login_cancel: PropTypes.func.isRequired,
        login_in: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
    };
    state = {
        inputValue: "",
        loadingStatus: false,
    };
    loginOutHandler = () => {
        this.props.login_out();
    };
    inputValueHandler = (event) => {
        const value = event.target.value;
        this.setState({
            inputValue: value,
        });
    };

    searchButtonHandler = async () => {
        //请求资源
        if (!this.props.login) {
            dialog4("鸭鸭提示", "使用之前必须登录哦～", this.showLoginModel);
            return;
        }
        if (this.state.loadingStatus) {
            return;
        }
        const value = this.state.inputValue;
        const url = parse_url_fromstring(value);
        if (!url) {
            dialog5("请输入正确的链接");
            return;
        }
        const stamp = Date.now();
        const hideLoading = message.loading('解析中', 0);
        this.setState({
            loadingStatus: true
        })
        const res = await parseSourceUrl({
            url,
            t: stamp,
            pcinfo,
            user: this.props.login,
            token: asd(stamp + url) + asd(pcinfo + this.props.login),
        }).catch(e => {
            message.error('解析失败');
            this.setState({
                loadingStatus: false
            });
            hideLoading();
        });

        /* global layer */
        const loading = layer.msg(
            '<div class="rotate"><i class="layui-icon layui-icon-loading" style="font-size: 30px; color: #ffffff;"></i></div><div>解析中</div>',
            { time: 0 }
        );
        layer.close(loading);
        if (res.retCode === 612) {
            layer.alert("您的次数已用完，请使用小程序增加次数后使用", { icon: 2 });
            return;
        } else if (res.retCode !== 200) {
            console.log('未知错误');
            return;
        }
        if (res.types === "instagram" && res.type === "media") {
            res.imagelist = res.list
                .filter((ele) => !ele.is_video)
                .map((ele) => ele.rawimg);
            res.video = res.list
                .filter((ele) => ele.is_video)
                .map((ele) => ele.video);
            console.log(res.video);
        }
        let { video, imagelist, desc } = res;
        const videos = !video ? [] : Array.isArray(video) ? video : [video];
        const xImagelist = (imagelist || []).map((ele) => ({
            url: ele,
            select: true,
        }));

        const jsx = <DownloadPanel videos={videos} xImagelist={xImagelist} desc={desc} />
        const clsKey = 'soutuya-' + uuid().replace(/\-/g, '').slice(0, 5);
        layer.open({
            type: 1,
            title: this.state.inputValue,
            area: ["600px", "100vh"],
            shade: 0,
            maxmin: true,
            content: `<div class="${clsKey}"></div>`,
            zIndex: 100,
        });
        setTimeout(() => {
            ReactDOM.render(jsx, document.querySelector('.' + clsKey));
            hideLoading();
            this.setState({
                loadingStatus: false
            })
        });
    };
    showAboutHandler = () => {
        layer.open({
            type: 1,
            title: false, //不显示标题栏
            closeBtn: false,
            area: ["400px", "600px"],
            shade: 0.8,
            id: "LAY_layuipro1", //设定一个id，防止重复弹出
            btn: ["好的"],
            btnAlign: "c",
            moveType: 1, //拖拽模式，0或者1
            content:
                '<div style="padding: 20px; line-height: 22px; background-color: #393D49; color: #fff; font-weight: 300;">' +
                serverInfo +
                "</div>",
            yes: function () {
                layer.closeAll();
            },
        });
    }
    showAPIHandler = () => {
        layer.open({
            type: 1,
            title: false, //不显示标题栏
            closeBtn: false,
            area: "300px;",
            shade: 0.8,
            id: "LAY_layuipro1", //设定一个id，防止重复弹出
            btn: ["好的"],
            btnAlign: "c",
            moveType: 1, //拖拽模式，0或者1
            content:
                '<div style="padding: 50px; line-height: 22px; background-color: #393D49; color: #fff; font-weight: 300;">如果您需要使用搜图鸭API，部署在网站、App或者小程序上，请添加微信：<span style="color:#f7c544;">successToast</span>。备注：api</div>',
            yes: function () {
                layer.closeAll();
            },
        });
    }
    render() {
        const loginStyle = {
            display: this.props.login ? "none" : "block",
        };
        const myStyle = {
            display: !this.props.login ? "none" : "block",
        };
        const vip_end = this.props.user.vip_end;
        const userInfo = {
            vipInfo: this.props.user.vip ? "已开通" : "未开通",
            vipMore: this.props.user.vip ? (
                <div
                    style={{
                        fontSize: "12px",
                        color: "#999999",
                    }}
                >
                    至:{vip_end.slice(0, 4)}年{vip_end.slice(4, 6)}月{vip_end.slice(6, 8)}
                    日 {vip_end.slice(8, 10)}:{vip_end.slice(10, 12)}:{vip_end.slice(12)}
                </div>
            ) : (
                ""
            ),
            vip: this.props.user.vip,
            count: this.props.user.vip ? "无限" : this.props.user.count,
        };
        return (
            <div className="bg">
                <div className="soft-nav">
                    <div>
                        <img
                            src={logo}
                            style={{
                                width: "100px",
                            }}
                            alt=""
                        />
                    </div>
                    <div className="soft-link">
                        <a className="can-click" onClick={this.showAPIHandler}>
                            API
                        </a>
                        <a className="can-click" onClick={this.showAboutHandler}>
                            关于
                        </a>
                        <a
                            className="can-click"
                            onClick={this.showLoginModel}
                            style={loginStyle}
                        >
                            登录
                        </a>
                        <div className="btn-group" style={myStyle}>
                            <button
                                type="button"
                                className="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                            >
                                <i
                                    className="layui-icon layui-icon-vercode"
                                    style={{
                                        color: "#009688",
                                        fontSize: "17px",
                                    }}
                                ></i>{" "}
                                我的 <span className="caret"></span>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a className="can-click">
                                        会员信息：{userInfo.vipInfo}
                                        {userInfo.vipMore}
                                    </a>
                                </li>
                                <li className="divider"></li>
                                <li>
                                    <a className="can-click">可用次数：{userInfo.count}次</a>
                                </li>
                                <li className="divider"></li>
                                <li>
                                    <a className="can-click" onClick={this.loginOutHandler}>
                                        退出登录
                                        <i
                                            className="layui-icon layui-icon-triangle-r"
                                            style={{ color: "#1E9FFF" }}
                                        ></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="info">
                    <h1>搜图鸭</h1>
                    <p>一键下载没有水印的图片、视频</p>
                </div>
                <div className="search">
                    <div className="col-lg-6">
                        <div className="input-group">
                            <input
                                type="text"
                                value={this.state.inputValue}
                                onChange={this.inputValueHandler}
                                className="form-control"
                                placeholder="请输入要解析的链接"
                            />
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={this.searchButtonHandler}
                                >
                                    <span className="glyphicon glyphicon-search"></span>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
